export const headerContentHeight = 80
export const subPageNavHeight = 40
export const headerHeight = headerContentHeight + subPageNavHeight
export const filterBarHeight = 56
export const mainNavWidth = 96
export const tableOfContentsWidth = 220
